export enum Breadcrumb {
  BRAND = 'brand',
  BRANDS = 'brands',
  KITCHEN_CENTER = 'kitchen-center',
  KITCHEN_CENTERS = 'kitchen-centers',
  STORE = 'store',
  STORES = 'stores',
  PARTNER = 'partner',
  PARTNERS = 'partners',
  PAYMENT_FOR_STORES = 'payment-for-stores',
  STORE_PARTNER = 'store-partner',
  STORE_PARTNERS = 'store-partners',
  CATEGORY = 'category',
  CATEGORIES = 'categories',
  EXTRA_CATEGORY = 'extra-category',
  EXTRA_CATEGORIES = 'extra-categories',
  PRODUCT = 'product',
  PRODUCTS = 'products',
  PARTNER_PRODUCT = 'partner-product',
  PARTNER_PRODUCTS = 'partner-products',
  CASHIER = 'cashier',
  CASHIERS = 'cashiers',
  ORDER = 'order',
  ORDERS = 'orders',
  BANKING_ACCOUNT = 'banking-account',
  BANKING_ACCOUNTS = 'banking-accounts',
  MONEY_EXCHANGES = 'money-exchanges',
  SHIPPER_PAYMENTS = 'shipper-payments',
  TRANSACTION = 'transaction',
  TRANSACTIONS = 'transactions',
  WALLET = 'wallet',
  LIST = 'list',
  DETAIL = 'detail',
  REGISTER = 'registration',
  UPDATE = 'updation',
  CREATE = 'creation',
  PROFILE = 'profile',
  INFORMATION = 'information',
  CONFIGURATIONS = 'configurations',
  END_OF_SHIFT = 'end-of-shift',
  TRANSFER_MONEY = 'transfer-money',
}
